/* eslint-disable react/no-danger */
// eslint-disable-next-line react/no-danger
import React from 'react';

import { getValue } from '@/helpers/GetValueHelper';

import { HeaderInformation } from './HeaderInformation';
import { THeaderProps } from './types';

export const Header = ({ data }: THeaderProps) => {
  const description = getValue(data, 'description', '');

  return (
    <header className="vitrine-template2__header">
      <div className="vitrine-template2__header--content">
        <HeaderInformation
          prefix={getValue(data, 'header.prefix', '')}
          has_icon={getValue(data, 'header.has_icon', false)}
          suffix={getValue(data, 'header.suffix', '')}
        />
      </div>
      <div className="vitrine-template2__header--main">
        <h3
          className="vitrine-template2__header--maintitle"
          dangerouslySetInnerHTML={{
            __html: getValue(data, 'title', ''),
          }}
        />
      </div>
      {description && (
        <div
          className="vitrine-template2__header--description"
          dangerouslySetInnerHTML={{
            __html: getValue(data, 'description', ''),
          }}
        />
      )}
    </header>
  );
};
